import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.83325 5.8335L14.1666 14.1668M14.1666 5.8335L5.83325 14.1668",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgClose;
